import React, { Component } from 'react';

class TableIndexWeb extends Component {
    render() {
        return (
            <React.Fragment>
                <div className="content main-card mb-3 card">
                    <div className="card-body">
                        <table className="table table-hover table-striped table-bordered" id="sampleTable">
                            <thead>
                                <tr>
                                    <th>Proceso</th>
                                    <th>Fecha de análisis</th>
                                    <th>Responsable</th>
                                    {(this.props.estados.editar || this.props.estados.eliminar) && (
                                        <th className="text-center"></th>
                                    )}
                                </tr>
                            </thead>

                            <tbody>
                                {this.props.data.length >= 1 ? (
                                    this.props.data.map(efect => (
                                        <tr key={efect.id}>
                                            <td>{efect.proceso}</td>
                                            <td>{efect.date_of_analysis}</td>
                                            <td>{efect.responsable != undefined ? efect.responsable.first_name : ""} {efect.responsable != undefined ? efect.responsable.first_last_name : ""}</td>

                                            {(this.props.estados.editar || this.props.estados.eliminar) && (
                                                <td className="text-right" style={{ width: "10px" }}>
                                                    <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
                                                        <div className="btn-group" role="group">
                                                            <button
                                                                className="btn-shadow btn btn-info"
                                                                id="btnGroupDrop1"
                                                                type="button"
                                                                data-toggle="dropdown"
                                                                aria-haspopup="true"
                                                                aria-expanded="false"
                                                            >
                                                                <i className="fas fa-bars"></i>
                                                            </button>

                                                            <div className="dropdown-menu dropdown-menu-right">
                                                                {this.props.estados.gestionar && (
                                                                    <a
                                                                        href={`/failure/efects/${efect.id}/efect_activities`}
                                                                        data-turbolinks="false"
                                                                        className="dropdown-item"
                                                                    >
                                                                        Gestionar
                                                                        </a>
                                                                )}

                                                                {this.props.estados.editar && (
                                                                    <button
                                                                        onClick={() => this.props.edit(efect)}
                                                                        className="dropdown-item"
                                                                    >
                                                                        Editar
                                                                        </button>
                                                                )}

                                                                {this.props.estados.eliminar && (
                                                                    <button
                                                                        onClick={() => this.props.delete(efect.id)}
                                                                        className="dropdown-item"
                                                                    >
                                                                        Eliminar
                                                                        </button>
                                                                )}
                                                            </div>

                                                        </div>
                                                    </div>
                                                </td>
                                            )}
                                        </tr>
                                    ))
                                ) : (
                                        <tr>
                                            <td colSpan="8" className="text-center">
                                                <div className="text-center mt-4 mb-4">
                                                    <h4>No hay registros</h4>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default TableIndexWeb;